import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import * as serviceCostModel from '../service-cost';
import { ServiceIntegrationsModel } from '../ServiceIntegrations';
import { ServiceTemplateBundlePricingTypeEnum } from './model';
const pricingTypeFromDTO = (dto)=>dto.type === ServiceTemplateBundlePricingTypeEnum.Fixed ? {
        type: ServiceTemplateBundlePricingTypeEnum.Fixed
    } : {
        type: ServiceTemplateBundlePricingTypeEnum.Variable,
        variable: {
            cap: dto.variable.cap ? new Decimal(dto.variable.cap).div(100) : null,
            name: dto.variable.name
        }
    };
const pricingTypeToDTO = (pricingType)=>pricingType.type === ServiceTemplateBundlePricingTypeEnum.Fixed ? {
        type: ServiceTemplateBundlePricingTypeEnum.Fixed
    } : {
        type: ServiceTemplateBundlePricingTypeEnum.Variable,
        variable: {
            cap: pricingType.variable.cap ? pricingType.variable.cap.mul(100).toNumber() : null,
            name: pricingType.variable.name
        }
    };
const pricingTypeFromService = (service)=>serviceCostModel.match(service.cost, {
        fixed: ()=>({
                type: ServiceTemplateBundlePricingTypeEnum.Fixed
            }),
        variable: (variable)=>({
                type: ServiceTemplateBundlePricingTypeEnum.Variable,
                variable: {
                    cap: variable.unitCap,
                    name: variable.unitName
                }
            }),
        range: ()=>{
            throw new Error('Invalid pricing type - Range is not supported for service bundles');
        }
    });
export const fromDTO = (dto)=>({
        pricingType: pricingTypeFromDTO(dto.pricingType),
        services: dto.services.map(includedServiceFromDTO)
    });
export const toDTO = (bundle)=>({
        pricingType: pricingTypeToDTO(bundle.pricingType),
        services: bundle.services.map(includedServiceToDTO)
    });
export const fromService = (service)=>({
        pricingType: pricingTypeFromService(service),
        services: service.bundle ? service.bundle.services.map((s)=>({
                id: s.serviceTemplateId || '',
                name: s.name,
                description: s.description,
                terms: s.terms,
                rate: s.rate,
                integrations: s.integrations
            })) : []
    });
export const toServiceBundle = (bundle)=>({
        services: bundle.services.map((service)=>_object_spread_props(_object_spread({}, service), {
                id: generateUniqueId('service-bundle'),
                serviceTemplateId: service.id
            }))
    });
export function includedServiceFromDTO(dto) {
    var _dto_terms;
    return _object_spread_props(_object_spread({}, dto), {
        terms: (_dto_terms = dto.terms) !== null && _dto_terms !== void 0 ? _dto_terms : '',
        rate: new Decimal(dto.rate).div(100),
        integrations: ServiceIntegrationsModel.fromDTO(dto.integrations)
    });
}
export function includedServiceToDTO(service) {
    return _object_spread_props(_object_spread({}, service), {
        rate: service.rate.mul(100).toNumber(),
        integrations: service.integrations.toJSON()
    });
}
